import { Form, Input, Typography } from "antd";
import { useTranslate } from "#src/hooks";
import { useAntTheme } from "hooks/useAntTheme/";

export const ObjectivesFormItem = ({
  isDefaultProjectMode = true,
  onChange,
}: {
  isDefaultProjectMode?: boolean;
  onChange?: (value: string) => void;
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  return (
    <>
      <Typography.Title
        level={4}
        style={{
          fontWeight: 400,
          margin: isDefaultProjectMode ? 5 : "undefined",
        }}
      >
        {t("projects.components.ProjectCreateWizard.addContextOrConstraints")}
      </Typography.Title>
      <Form.Item
        style={{ width: "100%", marginBottom: 8 }}
        rules={[
          {
            pattern: new RegExp(/^(?!.*\[[^[\]]+\]).*$/s),
            message: t(
              "projects.components.ProjectCreateWizard.fillValuesBrackets"
            ),
          },
        ]}
        name="description"
      >
        <Input.TextArea
          data-testid="objective-text-area"
          placeholder={t(
            "projects.components.ProjectCreateWizard.describeYourGoal"
          )}
          size={isDefaultProjectMode ? "small" : "large"}
          onChange={(e) => onChange?.(e.target.value)}
          rows={4}
          style={{
            boxShadow: theme.boxShadow,
            border: "none",
            width: "100%",
            padding: 10,
            textAlign: "left",
          }}
        />
      </Form.Item>
    </>
  );
};
